import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { getCustomers, getSites, getDevices, getCameras, getViews, getUsers, updateCustomers, updateSites, updateDevices, updateCameras, updateViews, updateUsers, } from '../../actions';
import { formatDisplayTS } from '../common/Utilities';
import '../../App.css';

import HeaderBlock from './HeaderBlock';
import UserForm from './forms/user/UserForm';
import CustomerForm from './forms/customer/CustomerForm';
import SiteForm from './forms/site/SiteForm';
import DeviceForm from './forms/device/DeviceForm';
import CameraForm from './forms/camera/CameraForm';
import ViewForm from './forms/view/ViewForm';
import Dialog from '../common/Dialog';
import { FaEdit, FaCircle, FaList } from 'react-icons/fa';
import {GrContactInfo} from 'react-icons/gr';

const Admin = props => {
  const {
    adminNav,
    customers,
    sites,
    devices,
    cameras,
    views,
    users,
    user,
    token,
    deviceIdList,
    getCustomers,
    getSites,
    getDevices,
    getCameras,
    getViews,
    getUsers,
    updateCustomers,
    updateSites,
    updateDevices,
    updateCameras,
    updateViews,
    updateUsers,
  } = props

  const backendUrl = process.env.REACT_APP_BACKEND
  const [showNewForm, setShowNewForm] = useState(false)
  const [resetFilter, setResetFilter] = useState(false)
  const [filterActive, setFilterActive] = useState(false)
  const [arrayFiltered,setArrayFiltered] = useState([])
  const [showDetails,setShowDetails] = useState([])
  const [showEditForm, setShowEditForm] = useState(false)
  const [formData, setFormData] = useState({})
  const [camsFormatted,setCamsFormatted] = useState({})
  const [relatedTarget, setRelatedTarget] = useState({})
  const [submitFormFunc, setSubmitFormFunc] = useState(null)
  const [promptUnsavedChanges, setPromptUnsavedChanges] = useState(false)

  useEffect(() => {
    setFormData({})
    setShowEditForm(false)
    setShowNewForm(false)
    setResetFilter(true)
    setShowDetails([])
    setShowEditForm(false)

    const prepareData = async () => {
      switch(adminNav) {
        case 'customers':
          await getCustomers(deviceIdList, token, user)
          break
        case 'sites':
          await getSites(deviceIdList, token, user)
          break
        case 'devices':
          await getDevices(deviceIdList, token, user)
          break
        case 'cameras':
          await getCameras(deviceIdList, token, user)
          break
        case 'views':
          await getViews(deviceIdList, token, user)
          break
        case 'users':
          await getUsers(deviceIdList, token, user)
          break
        default:
          console.log('Admin subpage does not exist: ', adminNav);
      }
    }

    if (adminNav) {
      prepareData()
    }

  // eslint-disable-next-line
  }, [adminNav])

  useEffect(() => {
    const transformCameras = (cams) => {
      // merge camera profiles with same sDeviceID and bCamera into one camera entry
      let camArr = []
      cams.forEach(c => {
        // add in the bitrate and TS for the appropriate profile
        let profile = {
          ['sLastRequestTS' + c.bProfile]: c.sLastRequestTS,
          ['convertedTS' + c.bProfile]: c.convertedTS,
          ['bBitrate' + c.bProfile]: c.bBitrate,
        }

        // if a camera entry already exists, then just add the profile data, else push the new camera data + profile
        let camIndex = camArr.findIndex(ca => ca.sDeviceID === c.sDeviceID && ca.bCamera === c.bCamera)
        if (camIndex !== -1) {
          camArr[camIndex] = {...camArr[camIndex], ...profile}
        } else {
          let cam = {...c, ...profile}
          camArr.push(cam)
        }
      })
      setCamsFormatted(camArr);
    }

    if (cameras && cameras.length > 0) {
      transformCameras(cameras);
    }
  }, [cameras])

  const updateData = (form, input, del) => {
    let newData = {...formData, ...input}
    let newList = []

    switch (form) {
      case 'customer':
        newList = [...customers]

        if (del === true) { // delete
          setFormData({})
          newList = newList.filter(val => val.bID !== newData.bID)
        } else if (Object.keys(formData).length) { // update
          setFormData(newData)
          newList = newList.map(val => val.bID === newData.bID ? newData : val)
        } else { // insert
          newList.push(newData)
        }

        updateCustomers(newList)
        break

      case 'site':
        newList = [...sites]

        if (del === true) { // delete
          setFormData({})
          newList = newList.filter(val => val.bID !== newData.bID)
        } else if (Object.keys(formData).length) { // update
          setFormData(newData)
          newList = newList.map(val => val.bID === newData.bID ? newData : val)
        } else { // insert
          newList.push(newData)
        }

        updateSites(newList)
        break

      case 'device':
        // we can only update devices, no add/delete
        newList = [...devices]
        setFormData(newData)
        newList = newList.map(val => val.bID === newData.bID ? newData : val)
        updateDevices(newList)
        break

      case 'camera':
        // we can only update cameras, no add/delete
        newList = [...cameras]
        setFormData(newData)
        newList = newList.map(val => val.bID === newData.bID ? newData : val)
        updateCameras(newList)
        break

      case 'view':
        newList = [...views]

        if (del === true) { // delete
          setFormData({})
          newList = newList.filter(val => val.bID !== newData.bID)
        } else if (Object.keys(formData).length) { // update
          setFormData(newData)
          newList = newList.map(val => val.bID === newData.bID ? newData : val)
        } else { // insert
          newList.push(newData)
        }

        updateViews(newList)
        break

      case 'user':
        newList = [...users]

        if (del === true) { // delete
          setFormData({})
          newList = newList.filter(val => val.bID !== newData.bID)
        } else if (Object.keys(formData).length) { // update
          setFormData(newData)
          newList = newList.map(val => val.bID === newData.bID ? newData : val)
        } else { // insert
          newList.push(newData)
        }

        updateUsers(newList)
        break
      default:
        console.log('Form does not exist: ', form)
    }
  }

  const toggleDetails = (id)=> {
    let tempArr = [...showDetails];
    let target = showDetails.find(d => d === id);
    if (target) {
      tempArr = tempArr.filter(d => d !== id);
    } else {
      tempArr.push(id);
    }
    setShowDetails(tempArr);
  }

  const setFiltered = (arr) => {
    setArrayFiltered(arr)
    setShowDetails([])
  }

  const onBlurForm = (e, submitFormFunc) => {
    e.preventDefault()
    e.persist()
    e.stopPropagation()

    // only prompt if there were changes in the form (handled in child component)
    // and button clicked has class = track-changes (edit icon, header buttons)
    if (e.relatedTarget && e.relatedTarget.className.includes('track-changes')) {
      setRelatedTarget(e.relatedTarget)
      setSubmitFormFunc(() => submitFormFunc)
      setPromptUnsavedChanges(true)
    }
  }

  const handleUnsavedPromptResponse = (save) => {
    if (save) {
      setPromptUnsavedChanges(false)
      submitFormFunc()
      setRelatedTarget({})

      // set timeout so the prompt stays open while saving
      setTimeout(() => {
        setSubmitFormFunc(null)
      }, 500)

    } else {
      document.getElementById('form-wrapper').focus()
      setPromptUnsavedChanges(false)
      setSubmitFormFunc(null)

      setTimeout(() => {
        relatedTarget.click()
        setRelatedTarget({})
      }, 500)
    }
  }

  const displayNewForm = () => {
    setFormData({})
    setShowNewForm(true)
  }

  const closeNewForm = () => {
    if (!promptUnsavedChanges) {
      setFormData({})
      setShowNewForm(false)
    }
  }

  const displayEditForm = (data) => {
    setFormData(data)
    setShowEditForm(true)
  }

  const closeEditForm = () => {
    if (!promptUnsavedChanges) {
      setFormData({})
      setShowEditForm(false)
    }
  }

  const minimizeDetails = showDetails.length > 0
    ? <div style={{ cursor: 'pointer', padding: '.5vmin', paddingRight: '1vmin', paddingLeft: '1vmin', border: '2px solid grey', borderRadius: 5 }} onClick={() => setShowDetails([])}>
        <p style={{ margin: 0, fontSize: '1.4vmin', cursor: 'pointer' }}>
            minimize all {adminNav.slice(0, -1)} details
        </p>
      </div>
    : null

  const leftList = () => {
    if (arrayFiltered.length > 0) {
      return [...arrayFiltered]
    } else if (filterActive) {
      return false
    } else {
      switch (adminNav) {
        case 'customers': return customers
        case 'sites': return sites
        case 'devices': return devices
        case 'cameras': return (camsFormatted.length > 0) ? camsFormatted : cameras
        case 'views': return views
        default: return users
      }
    }
  }

  return (
    <div style={styles.container}>
      <HeaderBlock
        displayNewForm={displayNewForm}
        users={users}
        customers={customers}
        sites={sites}
        devices={devices}
        cameras={cameras}
        formattedCameras={camsFormatted}
        views={views}
        filterActive={filterActive}
        setFilterActive={setFilterActive}
        closeEditForm={closeEditForm}
        setFiltered={setFiltered}
        resetFilter={resetFilter}
        setResetFilter={setResetFilter} />

      <> {/* create new "xxxx" form */}
      {adminNav === 'customers' && showNewForm &&
        <div style={styles.formContainer}>
          <CustomerForm
            updateData={updateData}
            onBlur={onBlurForm}
            closeForm={closeNewForm}
            cloudAPI={backendUrl}
            deviceList={deviceIdList}
            token={token} />
        </div>
      }

      {adminNav === 'sites' && showNewForm &&
        <div style={styles.formContainer}>
          <SiteForm
            updateData={updateData}
            onBlur={onBlurForm}
            closeForm={closeNewForm}
            customers={customers}
            cloudAPI={backendUrl}
            deviceList={deviceIdList}
            token={token}
            userData={user} />
        </div>
      }

      {adminNav === 'views' && showNewForm &&
        <div style={styles.formContainer}>
          <ViewForm
            updateData={updateData}
            onBlur={onBlurForm}
            closeForm={closeNewForm}
            users={users}
            customers={customers}
            sites={sites}
            devices={devices}
            cameras={cameras}
            views={views}
            cloudAPI={backendUrl}
            deviceList={deviceIdList}
            token={token} />
        </div>
      }

      {adminNav === 'users' && showNewForm &&
        <div style={styles.formContainer}>
          <UserForm
            updateData={updateData}
            onBlur={onBlurForm}
            closeForm={closeNewForm}
            cloudAPI={backendUrl}
            devices={devices}
            sites={sites}
            customers={customers}
            cameras={cameras}
            views={views}
            deviceList={deviceIdList}
            token={token}
            userData={user} />
        </div>
      }
      </>

      {/* main */}
      <div style={styles.main}>

        <> {/* left column start */}
        {adminNav === 'customers' &&
          <div style={styles.listContainer}>
            <div style={styles.listHeader}>
              <p style={styles.listLabel}>Customers</p>
              <p style={styles.listCount}>
                  {customers && customers.length > 0 ? customers.length : 0}
              </p>
              {minimizeDetails}
            </div>

            <div style={styles.listItems}>
              {leftList() === false
                ? <div style={styles.noResultsFound}>No results found</div>
                : leftList().map( row => (
                    <div key={row.bID} style={{ ...styles.itemContainer, backgroundColor: formData.bID === row.bID ? 'rgba(255,255,255,0.1)' : 'transparent' }}>
                      <div style={styles.itemHeader} onClick={() => toggleDetails(row.bID)}>
                        <FaList style={{...styles.expandIcon, backgroundColor: showDetails.includes(row.bID) ? '#38ACEC' : 'black' }} />
                        <div style={{...styles.itemDetailRow, marginLeft: '.75vmin'}}>
                          <span>Name:</span>
                          <span>{row.sName}</span>
                        </div>
                      </div>

                      {showDetails.includes(row.bID) &&
                        <div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>File Directory:</span>
                            <span>{row.sDir}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Domain:</span>
                            <span>{row.sDomain}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Public:</span>
                            <span>{row.fPublic === 0 ? 'no' : 'yes'}</span>
                          </div>
                        </div>
                      }

                      <div tabIndex="0" className="track-changes" style={styles.itemButtons} onClick={() => displayEditForm(row)}>
                        <FaEdit style={styles.editIcon} />
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
        }

        {adminNav === 'sites' &&
          <div style={styles.listContainer}>
            <div style={styles.listHeader}>
              <p style={styles.listLabel}>Sites</p>
              <p style={styles.listCount}>
                {sites && sites.length > 0 ? sites.length : 0}
              </p>
              {minimizeDetails}
            </div>

            <div style={styles.listItems}>
              {leftList() === false
                ? <div style={styles.noResultsFound}>No results found</div>
                : leftList().map( row => (
                    <div key={row.bID} style={{ ...styles.itemContainer, backgroundColor: formData.bID === row.bID ? 'rgba(255,255,255,0.1)' : 'transparent' }}>
                      <div style={styles.itemHeader} onClick={() => toggleDetails(row.bID)}>
                        <FaList style={{...styles.expandIcon, backgroundColor: showDetails.includes(row.bID) ? '#38ACEC' : 'black' }} />
                        <div style={{...styles.itemDetailRow, marginLeft: '.75vmin'}}>
                          <span>Name:</span>
                          <span>{row.sName}</span>
                        </div>
                      </div>

                      <div style={styles.itemDetailRow}>
                        <span>Customer:</span>
                        <span>{row.sCustomerName}</span>
                      </div>

                      {showDetails.includes(row.bID) &&
                        <div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>Data Plan:</span>
                            <span>{row.bDataPlanGB} GB</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>File Directory:</span>
                            <span>{row.sDir}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>URL:</span>
                            <span>{row.url}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Report Errors:</span>
                            <span>{row.fReportErrors === 0 ? 'no' : 'yes'}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Timezone:</span>
                            <span>{row.sTimezone}</span>
                          </div>
                        </div>
                      }

                      <div tabIndex="0" className="track-changes" style={styles.itemButtons} onClick={() => displayEditForm(row)}>
                        <FaEdit style={styles.editIcon} />
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
        }

        {adminNav === 'devices' &&
          <div style={styles.listContainer}>
            <div style={styles.listHeader}>
              <p style={styles.listLabel}>Devices</p>
              <p style={styles.listCount}>
                {devices && devices.length > 0 ? devices.length : 0}
              </p>
              {minimizeDetails}
            </div>

            <div style={styles.listItems}>
              {leftList() === false
                ? <div style={styles.noResultsFound}>No results found</div>
                : leftList().map( row => (
                    <div key={row.bID} style={{ ...styles.itemContainer, backgroundColor: formData.bID === row.bID ? 'rgba(255,255,255,0.1)' : 'transparent' }}>
                      <div style={styles.itemHeader} onClick={() => toggleDetails(row.bID)}>
                        <FaList style={{...styles.expandIcon, backgroundColor: showDetails.includes(row.bID) ? '#38ACEC' : 'black' }} />
                        <div style={{...styles.itemDetailRow, marginLeft: '.75vmin'}}>
                          <span>Name:</span>
                          <span>{row.sName ? row.sName : '---'}</span>
                        </div>
                      </div>

                      <div style={styles.itemDetailRow}>
                        <span>Customer:</span>
                        <span>{row.sCustomerName}</span>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Site:</span>
                        <span>{row.sProjectName}</span>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>ID:</span>
                        <span>{row.sDeviceID}</span>
                      </div>

                      {showDetails.includes(row.bID) &&
                        <div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>IP Address:</span>
                            <span>{row.sCurrentIP}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Backend ID:</span>
                            <span>{row.sBackendID}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Cameras Licensed:</span>
                            <span>{row.bCameras}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Last Event TS:</span>
                            <span>{row.convertedTS ? formatDisplayTS(row.convertedTS, true) : (row.sLastEventTS ? formatDisplayTS(row.sLastEventTS, false) : '')}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Online:</span>
                            <span>{row.fOnline === 0 ? 'no' : 'yes'}</span>
                          </div>
                        </div>
                      }

                      <div style={styles.itemButtons}>
                        {row.fOnline === 1
                          ? <FaCircle title="online" color={'mediumseagreen'} />
                          : <FaCircle title="offline" color={'tomato'} />
                        }

                        <div tabIndex="0" className="track-changes" onClick={() => displayEditForm(row)}>
                          <FaEdit style={styles.editIcon} />
                        </div>
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
        }

        {adminNav === 'cameras' &&
          <div style={styles.listContainer}>
            <div style={styles.listHeader}>
              <p style={styles.listLabel}>Cameras</p>
              <p style={styles.listCount}>
                {cameras && cameras.length > 0 && camsFormatted && camsFormatted.length > 0 ? camsFormatted.length : 0}
              </p>
              {minimizeDetails}
            </div>

            <div style={styles.listItems}>
              {leftList() === false
                ? <div style={styles.noResultsFound}>No results found</div>
                : leftList().map( row => (
                    <div key={row.bID} style={{ ...styles.itemContainer, backgroundColor: formData.bID === row.bID ? 'rgba(255,255,255,0.1)' : 'transparent' }}>
                      <div style={styles.itemHeader} onClick={() => toggleDetails(row.bID)}>
                        <FaList style={{...styles.expandIcon, backgroundColor: showDetails.includes(row.bID) ? '#38ACEC' : 'black' }} />
                        <div style={{...styles.itemDetailRow, marginLeft: '.75vmin'}}>
                          <span>Customer:</span>
                          <span>{row.sCustomerName}</span>
                        </div>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Site:</span>
                        <span>{row.sProjectName}</span>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Device ID:</span>
                        <span>{row.sDeviceID && row.sDeviceID.length > 0 ? row.sDeviceID : '???'}</span>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Device:</span>
                        <span>{row.sDeviceName && row.sDeviceName.length > 0 ? row.sDeviceName : '???'}</span>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Name:</span>
                        <span>{row.sName && row.sName.length > 0 ? row.sName : 'Cam ' + row.bCamera}</span>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Camera:</span>
                        <span>{row.bCamera}</span>
                      </div>

                      {showDetails.includes(row.bID) &&
                        <div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>Enabled:</span>
                            <span>{row.fEnabled}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Online:</span>
                            <span>{row.fOnline}</span>
                          </div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>Profile 1:</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Last Request:</span>
                            <span>{row.convertedTS1 ? formatDisplayTS(row.convertedTS1, true) : formatDisplayTS(row.sLastRequestTS1, false)}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Bitrate:</span>
                            <span>{row.bBitrate1}</span>
                          </div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>Profile 2:</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Last Request:</span>
                            <span>{row.convertedTS2 ? formatDisplayTS(row.convertedTS2, true) : formatDisplayTS(row.sLastRequestTS2, false)}</span>
                          </div>
                          <div style={styles.itemDetailRow}>
                            <span>Bitrate:</span>
                            <span>{row.bBitrate2}</span>
                          </div>
                        </div>
                      }

                      <div style={styles.itemButtons}>
                        {row.fEnabled === 0
                          ? <div style={styles.enabledBox}>disabled</div>
                          : <div style={{...styles.enabledBox, border: '2px solid mediumseagreen', backgroundColor: 'mediumseagreen', color: 'white'}}>enabled</div>
                        }

                        {row.fOnline === 1
                          ? <FaCircle title="online" color={'mediumseagreen'} />
                          : <FaCircle title="offline" color={'tomato'} />
                        }

                        <div tabIndex="0" className="track-changes" onClick={() => displayEditForm(row)}>
                          <FaEdit style={styles.editIcon} />
                        </div>
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
        }

        {adminNav === 'views' &&
          <div style={styles.listContainer}>
            <div style={styles.listHeader}>
              <p style={styles.listLabel}>Views</p>
              <p style={styles.listCount}>
                {views && views.length > 0 ? views.length : 0}
              </p>
              {minimizeDetails}
            </div>

            <div style={styles.listItems}>
              {leftList() === false
                ? <div style={styles.noResultsFound}>No results found</div>
                : leftList().map( row => (
                    <div key={row.bID} style={{ ...styles.itemContainer, backgroundColor: formData.bID === row.bID ? 'rgba(255,255,255,0.1)' : 'transparent' }}>
                      <div style={styles.itemHeader} onClick={() => toggleDetails(row.bID)}>
                        <FaList style={{...styles.expandIcon, backgroundColor: showDetails.includes(row.bID) ? '#38ACEC' : 'black' }} />
                        <div style={{...styles.itemDetailRow, marginLeft: '.75vmin'}}>
                          <span>Name:</span>
                          <span>{row.sName}</span>
                        </div>
                      </div>
                      <div style={styles.itemDetailRow}>
                        <span>Customer:</span>
                        <span>{row.sCustomerName}</span>
                      </div>

                      {showDetails.includes(row.bID) &&
                        <div>
                          <hr style={styles.hr} />
                          <div style={styles.itemDetailRow}>
                            <span>Cams:</span>
                            <span style={styles.accessList}>
                              {row.sCams && row.sCams.length > 2 && JSON.parse(row.sCams).map( c => {
                                let camera = cameras.find(cam => cam.bID === c)
                                return camera ? (
                                  <span style={styles.access} key={c}>
                                    {`${camera.sCustomerName} - ${camera.sDeviceName} : ${camera.sName && camera.sName.length > 0 ? camera.sName : `Cam ${c.bCamera}`}`}
                                  </span>
                                ) : null
                              })}
                            </span>
                          </div>
                        </div>
                      }

                      <div tabIndex="0" className="track-changes" style={styles.itemButtons} onClick={() => displayEditForm(row)}>
                        <FaEdit style={styles.editIcon} />
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
        }

        {adminNav === 'users' &&
          <div style={styles.listContainer}>
            <div style={styles.listHeader}>
              <p style={styles.listLabel}>Users</p>
              <p style={styles.listCount}>
                {arrayFiltered.length > 0
                  ? [...arrayFiltered].length
                  : users && users.length > 0
                    ? users.length : 0
                }
              </p>
              {minimizeDetails}
            </div>

            <div style={styles.listItems}>
              {leftList() === false
                ? <div style={styles.noResultsFound}>No results found</div>
                : leftList().map( row => (
                    <div key={row.bID} style={{ ...styles.itemContainer, backgroundColor: formData.bID === row.bID ? 'rgba(255,255,255,0.1)' : 'transparent' }}>

                      <div style={styles.itemHeader} onClick={() => toggleDetails(row.bID)}>
                        <GrContactInfo style={{...styles.expandIcon, backgroundColor: showDetails.includes(row.bID) ? '#38ACEC' : 'black' }} />
                        <div style={{...styles.itemDetailRow, marginLeft: '.75vmin'}}>
                          <span>Name:</span>
                          <span>{row.sDescription}</span>
                        </div>
                      </div>

                      <div style={styles.itemDetailRow}>
                        <span>Email / Login:</span>
                        <span style={{color: 'royalblue'}}>{row.sName}</span>
                      </div>

                      { showDetails.includes(row.bID) &&
                        <div>
                          <hr style={styles.hr} />
                          {row.access && row.access.length > 0
                            ? <div style={styles.itemDetailRow}>
                                <span>Site Access:</span>
                                <span style={styles.accessList}>
                                  {row.access.map( a => (
                                    <span style={styles.access} key={a.bProjectID}>{a.sProjectName}</span>
                                  ))}
                                </span>
                              </div>
                            : <div style={styles.itemDetailRow}><span>Site Access: none</span></div>
                          }

                          <hr style={styles.hr} />
                          {row.sViews && row.sViews.length > 2
                            ? <div style={styles.itemDetailRow}>
                                <span>View Access:</span>
                                <span style={styles.accessList}>
                                  {JSON.parse(row.sViews).map(v => (
                                    <span key={v} style={styles.access}>{views && views.length > 0 && views.find(view => view.bID === parseInt(v)) ? views.find(view => view.bID === parseInt(v)).sName : '' }</span>
                                  ))}
                                </span>
                              </div>
                            : <div style={styles.itemDetailRow}><span>View Access: none</span></div>
                          }
                        </div>
                      }

                      <div tabIndex="0" className="track-changes" style={styles.itemButtons} onClick={() => displayEditForm(row)}>
                        <FaEdit style={styles.editIcon} />
                      </div>
                    </div>
                  ))
              }
            </div>
          </div>
        }
        </>

        {/* right column start */}
        <div style={styles.rightContainer}>
          {adminNav === 'customers' && showEditForm && formData.bID &&
            <CustomerForm
              updateData={updateData}
              onBlur={onBlurForm}
              closeForm={closeEditForm}
              customer={formData}
              cloudAPI={backendUrl}
              deviceList={deviceIdList}
              token={token} />
          }
          {adminNav === 'sites' && showEditForm && formData.bID &&
            <SiteForm
              updateData={updateData}
              onBlur={onBlurForm}
              closeForm={closeEditForm}
              site={formData}
              customers={customers}
              cloudAPI={backendUrl}
              deviceList={deviceIdList}
              token={token}
              userData={user} />
          }
          {adminNav === 'devices' && showEditForm && formData.bID &&
            <DeviceForm
              setResetFilter={setResetFilter}
              updateData={updateData}
              onBlur={onBlurForm}
              closeForm={closeEditForm}
              device={formData}
              customers={customers}
              sites={sites}
              cloudAPI={backendUrl}
              deviceList={deviceIdList}
              token={token} />
          }
          {adminNav === 'cameras' && showEditForm && formData.bID &&
            <CameraForm
              setResetFilter={setResetFilter}
              updateData={updateData}
              onBlur={onBlurForm}
              closeForm={closeEditForm}
              camera={formData}
              cloudAPI={backendUrl}
              deviceList={deviceIdList}
              token={token} />
          }
          {adminNav === 'views' && showEditForm && formData.bID &&
            <ViewForm
              updateData={updateData}
              onBlur={onBlurForm}
              closeForm={closeEditForm}
              view={formData}
              customers={customers}
              cameras={cameras}
              cloudAPI={backendUrl}
              deviceList={deviceIdList}
              token={token} />
          }
          {adminNav === 'users' && showEditForm && formData.bID &&
            <UserForm
              updateData={updateData}
              onBlur={onBlurForm}
              closeForm={closeEditForm}
              user={formData}
              sites={sites}
              customers={customers}
              devices={devices}
              cameras={cameras}
              views={views}
              cloudAPI={backendUrl}
              deviceList={deviceIdList}
              userData={user}
              token={token} />
          }
        </div>

        {promptUnsavedChanges &&
          <Dialog
            overlayStyle = {{zIndex: 100}}
            title = "WARNING"
            content = "You have some unsaved changes. Would you like to save it?"
            buttons = {[
              {label: 'Save', onClick: () => handleUnsavedPromptResponse(true)},
              {label: 'Discard', onClick: () => handleUnsavedPromptResponse(false)}
            ]}
          />
        }
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { adminNav } = state.config;
  const { customers, sites, devices, cameras, views, users } = state.admin
  const { user, token } = state.auth
  const { deviceIdList } = state.data
  return {
    adminNav,
    customers,
    sites,
    devices,
    cameras,
    views,
    users,
    user,
    token,
    deviceIdList,
  }
}
export default connect(mapStateToProps, {
  getCustomers,
  getSites,
  getDevices,
  getCameras,
  getViews,
  getUsers,
  updateCustomers,
  updateSites,
  updateDevices,
  updateCameras,
  updateViews,
  updateUsers,
})(Admin)

const styles = {
  container: {
    width: '75vw',
    padding: '2vmin',
    border: '2px solid gray',
    borderRadius: 5,
    backgroundColor: 'rgba(10, 14, 25, 0.6)',
    color: 'white',
  },
  formContainer: {
    borderRadius: 5,
    marginBottom: 40,
    backgroundColor: "rgba(0,0,0,0.8)",
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: '98%',
    height: '60vmin',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    margin: 'auto'
  },
  listContainer: {
    width: '50%',
    height: "100%"
  },
  listHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2vmin',
    marginTop: '2vmin',
    width: '100%',
    height: '3vmin',
    gap: '1vmin',
  },
  listLabel: {
    fontWeight: 'bold',
    textDecoration: 'underline',
    fontSize: '2.4vmin'
  },
  listCount:  {
    textAlign: 'center',
    height: '2.5vmin',
    width: '2.5vmin',
    lineHeight: '2vmin',
    borderRadius: '50%',
    border: '2px solid grey',
    fontSize: '1.2vmin'
  },
  listItems: {
    height: '90%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  noResultsFound: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '1.8vmin',
  },
  itemContainer: {
    width: '95%',
    height: 'auto',
    border: '2px solid grey',
    borderRadius: 5,
    padding: '.5vmin',
    paddingLeft: '1vmin',
    marginBottom: '.5vmin',
    position: 'relative',
  },
  itemHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer'
  },
  expandIcon: {
    border: '2px solid grey',
    borderRadius: 5,
    padding: '.25vmin .5vmin',
    width: '3vmin',
    height: '3vmin',
  },
  itemDetailRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '1vmin',
    margin: '0 0 0 4vmin',
    fontSize: '1.6vmin',
  },
  hr: {
    margin: '1.5vmin 1vmin',
  },
  accessList: {
    display: 'flex',
    flexDirection: 'column',
  },
  access: {
    fontSize: '1.4vmin',
    paddingBottom: '.5vmin',
  },
  itemButtons: {
    position: 'absolute',
    top: '.5vmin',
    right: '.5vmin',
    display: 'flex',
    gap: '1vmin',
    alignItems: 'center',
    fontSize: '2vmin',
  },
  editIcon: {
    cursor: 'pointer',
    outline: '0',
  },
  enabledBox: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    fontSize: '1vmin',
    padding: '.1vmin 2vmin',
    border: '2px solid grey',
  },
  rightContainer: {
    width: '48%',
    height: '100%',
    paddingTop: '7vmin',
  },
}